import { defineComponent } from "vue";

import { NNumberAnimation, NTooltip } from 'naive-ui'

import WidgetBase from "../widget-base/widget-base";
import { DashboardFilterEnum } from "~/models/dashboard/dashboard-filter.enum";


export default defineComponent({

    components: {
        WidgetBase,

        NTooltip,
        NNumberAnimation,
    },

    props: {
        title: { type: String },
        description: { type: String},
        value: {},
        unit: { type: String },
        valueColor: { type: String },
        variation: { type: Number },
        variationColor: { type: String },
        tooltip: { type: String },
        loading: { type: Boolean }
    },

    data() {
        return {
            previous: 0,
            next: 0,

            filter: DashboardFilterEnum.ALL,
            DashboardFilterEnum,
        }
    },

    mounted(): void {
        if(typeof this.value === 'number') {
            this.next = this.value;
        }
    },

    watch: {
        
        value(value, old) {
            if(old === value) {
                return;
            }

            this.previous = old;
            this.next = value;
        },
    }
});